module.exports = __webpack_public_path__ + "static/media/copy.6583ff09.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Exchange/scenes/NoDeposits/img/copy.svg
// module id = 165
// module chunks = 0